import React from "react";

interface RDItem {
  title: string;
  image: string;
}

const items: RDItem[] = [
  {
    title: "Material Synthesis and Science",
    image: "/rd/rd1.png",
  },
  {
    title: "Cell Manufacturing Technology",
    image: "/rd/rd2.png",
  },
  {
    title: "Material Characterisation",
    image: "/rd/rd3.png",
  },
  {
    title: "Prototyping and Testing",
    image: "/rd/rd4.png",
  },
];

const RDFacility: React.FC = () => {
  return (
    <section className="relative py-20 bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden">
      <div className="absolute -top-20 right-10 w-80 h-80 bg-indigo-300/20 blur-[130px] rounded-full"></div>

      <div className="max-w-8xl mx-auto px-6 lg:px-12 relative z-[1]">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Advanced <span className="text-sky-500"> R&D Processes</span>
          </h2>

          <p className="mt-4 text-gray-600 text-lg leading-relaxed">
            At Devananta, innovation is built through disciplined research
            processes along with infrastructure. Our work combines advanced
            engineering practices, industry-standard testing methods, and
            continuous learning to push the boundaries of cell performance and
            safety.
          </p>
        </div>

        <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {items.map((item, i) => (
            <div
              key={i}
              className="group relative bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
            >
              <div className="relative h-52 md:h-64 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-all duration-500"
                />
              </div>

              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900">
                  {item.title}
                </h3>
              </div>

              <div className="absolute -bottom-10 right-0 w-40 h-40 bg-indigo-300/20 blur-[80px] rounded-full pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RDFacility;
